import { Component, input } from '@angular/core';

@Component({
    selector: 'app-image-column',
    template: `
    <div class="vertical-column">
      <div class="image">
      <img alt="Crop Growth Stages" class="header-image" [src]="imgSrc()" />
      </div>
    </div>
  `,
    styleUrl: './image-column.component.scss',
})
export class ImageColumnComponent {
  imgSrc = input<string>();
}
